import React from 'react';
import { useTranslation } from 'react-i18next';
import { useUpdateCargoItem } from 'api/cargo-items/use-update-cargo-item.ts';
import type { UpdateCargoItemReq } from 'api/swagger';
import { CargoType } from 'types/cargo';
import { CargoItemEditForm } from 'components/cargos/cargo-item-edit/components/cargo-item-edit-form';
import { FormDrawer, EFormDrawerSize } from 'components/common/form-drawer';
import type { ICargoItemEditProps } from './types';

export const CargoItemEdit: React.FC<ICargoItemEditProps> = (props) => {
  const { isOpen, onClose, cargoItem, cargoType } = props;
  const { t } = useTranslation();

  const { mutateAsync: updateCargoItem, isLoading } = useUpdateCargoItem(cargoItem.cargoId, cargoItem.id);
  const isContainer = cargoType === CargoType.CONTAINER;

  const onFinish = async (values: UpdateCargoItemReq) => {
    const payload: UpdateCargoItemReq = isContainer ? { type: values.type, weight: values.weight } : values;

    await updateCargoItem(payload);
    onClose();
  };

  const initialValues: UpdateCargoItemReq = {
    width: cargoItem.width,
    height: cargoItem.height,
    length: cargoItem.length,
    stack: cargoItem.stack,
    weight: cargoItem.weight,
    type: cargoItem.type,
  };

  return (
    <FormDrawer
      formComponent={CargoItemEditForm}
      formProps={{ initialValues, isContainer }}
      title={t('cargo:edit_cargo_item')}
      isLoading={isLoading}
      size={EFormDrawerSize.LARGE}
      isOpen={isOpen}
      onClose={onClose}
      onFinish={onFinish}
    />
  );
};
